import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import ImageModal from "../../../modules/Dashboard/DashboardComponent/ImageModalComponent/ImageModalComponent";

const Whatsnew = () => {
  const dispatch = useDispatch();
  const [newJoinee, setNewJoinee] = useState([]);
  const [newProject, setNewProject] = useState([]);
  const [newLetter, setNewLetter] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);

  const closeModal = useCallback(() => {
    setModalImage(null);
  }, []);
  const handleImageClick = useCallback((imageUrl) => {
    setModalImage(imageUrl);
  }, []);
  const fetchForthComingDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}org/whatnew`);

      if (response?.status === 200) {
        // Modified function to sort by farthest date (descending order)
        const sortByFarthestDate = (array, dateField = "Date") => {
          if (!array || array.length === 0) return [];

          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const currentYear = today.getFullYear();

          const getNextOccurrence = (dateStr) => {
            const date = new Date(dateStr);
            const nextDate = new Date(date);
            nextDate.setFullYear(currentYear);

            if (nextDate < today) {
              nextDate.setFullYear(currentYear + 1);
            }
            return nextDate;
          };

          return [...array].sort((a, b) => {
            // Handle case where date might be in different fields
            const dateA = a[dateField] || a["DATE"] || a["date"];
            const dateB = b[dateField] || b["DATE"] || b["date"];

            const nextA = getNextOccurrence(dateA);
            const nextB = getNextOccurrence(dateB);
            return nextB - nextA; // Changed from nextA - nextB to nextB - nextA for descending order
          });
        };

        // Apply sorting to each data set
        const newJoiningData = sortByFarthestDate(
          response?.data?.data?.newjoining
        );
        setNewJoinee(newJoiningData);

        const newData = sortByFarthestDate(
          response?.data?.data?.newLetterWhatsNew
        );
        setNewLetter(newData);

        const projectData = sortByFarthestDate(
          response?.data?.data?.newProject
        );
        setNewProject(projectData);
      }
    } catch (error) {
      console.error("Error fetching ForthComing Details:", error);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    fetchForthComingDetails();
  }, []);
  useEffect(() => {
    dispatch(updateNavbarHeading("What's New?"));
  }, []);

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid mt-2">
          <div className="row g-2">
            <div className="col-lg-6">
              <div className="forth-card shadow-sm h-100">
                <div className="forth-card-header">
                  <h6>
                    <strong>Welcome to the Nice Family</strong>
                  </h6>
                </div>
                <div className="card-body px-2 forthcoming-card-body">
                  {newJoinee.map((joinee) => (
                    <div class="forth-person-card mb-2">
                      <div
                        key={joinee.ID}
                        className="d-flex align-items-center p-1"
                      >
                        <div className="forth-img-joinee">
                          <img
                            src={joinee.ImagePath || ""}
                            alt={joinee.title}
                            className="forth-img-joinee"
                            onClick={() => handleImageClick(joinee.ImagePath)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="forth-person-name">{joinee.title}</h6>
                          <p className="forth-person-position">
                            {joinee.Message}
                          </p>
                        </div>
                        <div className="forth-date">
                          <span className="forth-date-icon me-1">
                            <i className="bi bi-calendar-week"></i>
                          </span>
                          {moment(joinee.Date).format("ddd, MMM D")}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="forth-card shadow-sm h-100">
                <div className="forth-card-header">
                  <h6>
                    <strong>Activities @Nice</strong>
                  </h6>
                </div>
                <div className="card-body px-2 forthcoming-card-body">
                  {newLetter.map((joinee) => (
                    <div class="forth-person-card mb-2">
                      <div
                        key={joinee.ID}
                        className="d-flex align-items-center p-1"
                      >
                        <div className="forth-img-joinee">
                          <img
                            src={joinee.ImagePath || ""}
                            alt={joinee.title}
                            className="forth-img-joinee"
                            onClick={() => handleImageClick(joinee.ImagePath)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="forth-person-name">{joinee.title}</h6>
                          <p className="forth-person-position">
                            {joinee.Message}
                          </p>
                        </div>
                        <div className="forth-date">
                          <span className="forth-date-icon me-1">
                            <i className="bi bi-calendar-week"></i>
                          </span>
                          {moment(joinee.Date).format("ddd, MMM D")}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-12" style={{ marginTop:"8px" }}>
              <div className="forth-card shadow-sm h-100">
                <div className="forth-card-header">
                  <h6>
                    <strong>Recent/New Projects</strong>
                  </h6>
                </div>
                <div className="card-body px-2 forthcoming-card-body">
                  {newProject
                    .sort((a, b) => new Date(b.DATE) - new Date(a.DATE))
                    .map((item) => (
                      <div class="forth-person-card mb-2" key={item.ID}>
                        <div className="d-flex align-items-center p-1">
                          <div className="forth-img-div">
                            <img
                              src={item.ImagePath || ""}
                              alt={item.title}
                              className="forth-img"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="forth-person-name">{item.title} </h6>
                            <p className="forth-person-position">
                              {item.Message}
                            </p>
                          </div>
                          <div className="forth-date">
                            <span className="forth-date-icon me-1">
                              <i className="bi bi-calendar-week"></i>
                            </span>
                            {moment(item.DATE).format("ddd, MMM D")}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <ImageModal
            isOpen={!!modalImage}
            imageUrl={modalImage}
            onClose={closeModal}
          />
        </div>
      </>
    );
  }
};

export default Whatsnew;
